/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Change_StageInputs */

const cs_action_change_stage = /** @type {(inputs: Action_Change_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout do fáze`)
};

const en_action_change_stage = /** @type {(inputs: Action_Change_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to stage`)
};

/**
* | output |
* | --- |
* | "Move to stage" |
*
* @param {Action_Change_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_change_stage = /** @type {((inputs?: Action_Change_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Change_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_change_stage(inputs)
	return cs_action_change_stage(inputs)
});